import { MAP_PAGE_ENQUIRY, MAP_PAGE_WORKPACK } from 'client/utils/routes/routeConstants';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';
import { setAlertOpen } from 'client/store/alertSlice/alertSlice';
import { addDrawStatus, removeDrawStatus, setDrawType, selectDrawType } from 'client/store/drawSlice/drawSlice';
import { useLocation } from 'react-router';
import DrawButton from './DrawButton/DrawButton';
import EditButton from './EditButton/EditButton';
import ClearButton from './ClearButton/ClearButton';
import CloseButton from './CloseButton/CloseButton';
import FinishButton from './FinishButton/FinishButton';
import BookMarkButton from './BookmarkButton/BookMarkButton';
import RecentreButton from './RecentreButton/RecentreButton';
import Search from './Search/Search';
import ContinueEnquiryButton from './ContinueEnquiryButton/ContinueEnquiryButton';
import ContinueWorkpackButton from './ContinueWorkpackButton/ContinueWorkpackButton';
import ContinueObservationButton from './ContinueObservationButton/ContinueObservationButton';
import CancelObservationButton from './CancelObservationButton/CancelObservationButton';
import { mapModeIncludesAll } from './validateModes';
import { BOX, LINE, POLYGON } from 'client/utils/constants/symbolName';
import { mapMenuTabKeys, mapModes } from 'client/utils/constants/appStates';
import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';
import styles from './MapToolBar.module.scss';
import DrawButtonAccordion from './DrawButtonDropdown/DrawButtonDropdown';
import LineWidthField from './LineWidthField/LineWidthField';
import { linearSearchFeatureFlag } from 'client/utils/constants/frontEndConfig';
import LegacyDrawButton from './DrawButton/LegacyDrawButton';

const { DEFAULT, DRAWING, MODIFYING, AOI, LOADING, ADDING_OBSERVATION } = mapModes;

const MapToolBar = ({ mapMode, isEditingObservation, setCreateMobileAOIDialog }) => {
    const location = useLocation();
    const selectedTab = useSelector(state => state.map?.menuSelectedTab);
    const drawType = useSelector(selectDrawType);
    const deviceType = useDeviceType();
    const onIsolatedViewsTab = selectedTab === mapMenuTabKeys.ISOLATED_VIEWS;

    return (
        <div className={styles.toolbar}>
            <Search data-testid='mapToolBar.search'/>
            {onIsolatedViewsTab
                ? <div className={styles.drawButtons}>
                    <div className={styles.edit}>
                        <RecentreButton/>
                    </div>
                </div>
                : <>
                    <div className={styles.drawButtons}>
                        {
                            !mapMode.includes(ADDING_OBSERVATION) && (
                                <div className={styles.edit}>
                                    {deviceType !== DESKTOP
                                        ? <DrawButton disableAboveMaxScale={true}
                                            setCreateMobileAOIDialog={setCreateMobileAOIDialog} type={BOX}
                                            data-testid="mapToolBar.draw.mobile.box"/>
                                        : <>
                                            <EditButton/>
                                            {linearSearchFeatureFlag
                                                ? <DrawButtonAccordion />
                                                : <>
                                                    <LegacyDrawButton type={BOX} data-testid="mapToolBar.draw.box"/>
                                                    <LegacyDrawButton type={POLYGON} data-testid="mapToolBar.draw.polygon"/>
                                                </>
                                            }
                                            {drawType === LINE && (mapMode.includes(DRAWING) || mapMode.includes(MODIFYING)) && <LineWidthField />}
                                        </>
                                    }
                                    <ClearButton/>
                                    <RecentreButton/>
                                </div>
                            )
                        }
                    </div>
                    <div>
                        {(
                            !mapModeIncludesAll(mapMode, [DRAWING, DEFAULT]) &&
                            !mapModeIncludesAll(mapMode, [AOI, MODIFYING]) &&
                            !mapModeIncludesAll(mapMode, [ADDING_OBSERVATION]) &&
                            !mapModeIncludesAll(mapMode, [LOADING])
                        ) &&
                            <div className={styles.editEnd} data-testid={'bookmark-section-toolbar'}>
                                {!location.pathname.includes(MAP_PAGE_ENQUIRY) && !location.pathname.includes(MAP_PAGE_WORKPACK) ? <BookMarkButton/> : null}
                                {location.pathname.includes(MAP_PAGE_ENQUIRY) && mapModeIncludesAll(mapMode, [AOI])
                                    ? <ContinueEnquiryButton/>
                                    : null}
                                {location.pathname.includes(MAP_PAGE_WORKPACK) && mapModeIncludesAll(mapMode, [AOI])
                                    ? <ContinueWorkpackButton/>
                                    : null}
                            </div>
                        }
                        {(mapModeIncludesAll(mapMode, [ADDING_OBSERVATION]) && !mapModeIncludesAll(mapMode, [LOADING])) &&
                            <div className={styles.editEnd}>
                                {isEditingObservation ? <ContinueObservationButton/> : <CancelObservationButton/>}
                            </div>
                        }
                        {mapModeIncludesAll(mapMode, [MODIFYING]) &&
                            <div className={styles.save}>
                                <CloseButton/>
                                <FinishButton/>
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    );
};

MapToolBar.propTypes = {
    mapMode: PropTypes.array,
    addMapMode: PropTypes.func.isRequired,
    draftEnquiry: PropTypes.object,
    isEditingObservation: PropTypes.bool,
    setCreateMobileAOIDialog: PropTypes.func
};

MapToolBar.defaultProps = {
    mapMode: [],
    draftEnquiry: {},
    isEditingObservation: false
};
const mapStateToProps = state => {
    const { map, enquiries } = state;
    return {
        mapMode: map?.mode || [],
        draftEnquiry: enquiries?.draftEnquiry
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addMapMode: (payload) => dispatch(addMapMode(payload)),
        removeMapMode: (payload) => dispatch(removeMapMode(payload)),
        addDrawStatus: (payload) => dispatch(addDrawStatus(payload)),
        removeDrawStatus: (payload) => dispatch(removeDrawStatus(payload)),
        setDrawType: (payload) => dispatch(setDrawType(payload)),
        setAlertOpen: (payload) => dispatch(setAlertOpen(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapToolBar);
